import { FormOptional, FormShape, FormUnit, type GetFormInput } from "@suse-o11y/signal/form";

import { isStringDirty } from "~/tools/is-string-dirty";
import type { Partial } from "~/tools/partial";
import { trim } from "~/tools/trim";

import { FormState as DecimalsFormState } from "../decimals/form-state";
import { FormState as UnitFormState } from "../unit/form-state";

type LabelFormState = FormUnit<string, null, undefined | string>;

type FormState = FormOptional<
	FormUnit<boolean>,
	FormShape<{
		unit: UnitFormState;
		decimals: DecimalsFormState;
		label: LabelFormState;
	}>
>;

type Input = GetFormInput<FormState>;

const INITIAL = {
	enabled: true,
	element: {
		unit: UnitFormState.initial,
		decimals: DecimalsFormState.initial,
		label: "",
	},
} satisfies Input;

function init(initial?: Partial<Input, "deep">): FormState {
	return FormOptional(
		FormUnit(initial?.enabled ?? INITIAL.enabled),
		FormShape({
			unit: UnitFormState.init(initial?.element?.unit ?? INITIAL.element.unit),

			decimals: DecimalsFormState.init(initial?.element?.decimals ?? INITIAL.element.decimals),

			label: FormUnit(initial?.element?.label ?? INITIAL.element.label, {
				isInputDirty: isStringDirty,
				transform: trim,
			}),
		}),
	);
}

const FormState = {
	initial: INITIAL,
	init,
} as const;

export { FormState };
export type { LabelFormState };
